var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-container"},[_c('section',{class:['page-content', _vm.$route.name]},[_c('section',{staticClass:"page-change-password"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }